import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Fonts } from '../Label.h'

export interface ILabelInlineSecondaryTemplateSmBoldProps extends ILabelProps {}

export const LabelInlineSecondaryTemplateSmBold = ({
  title = '',
  color = COLOR.TEXT_ICON_SECONDARY,
  font = Fonts.FontSmBold,
  ...rest
}: ILabelInlineSecondaryTemplateSmBoldProps): JSX.Element => (
  <Label title={title} color={color} font={font} {...rest} />
)
